






import { Component, Vue, Watch } from 'vue-property-decorator';
import { namespace } from 'vuex-class';
import { RenderMenuMixin } from '@/mixins';
import { AcgnStaticsMenu, AcgnStatisticDetail } from '@/components';

@Component({
  components: {
    AcgnStaticsMenu,
    AcgnStatisticDetail
  },
  mixins: [RenderMenuMixin]
})

/**
 * 总览-明细
 */
export default class StatisticDetail extends Vue {

  // 渲染左侧菜单
  private renderMenu() {
    return (
      <acgn-statics-menu type="index"></acgn-statics-menu>
    );
  }
}
